import * as React from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import PopupLoading from "./../../PopupLoading";
import Avatar from "@mui/material/Avatar";
import UserSession from "./../../../services/UserSession";

import "./styles.scss";
import Joi from "joi";
import { PlayerDetails } from "../../../types/Game";

const avatars: Array<Avatar> = [
  {
    label: "Image",
    image: "/images/player/imageAvatar1.png",
    value: "1",
  },
  {
    label: "Image",
    image: "/images/player/imageAvatar2.png",
    value: "2",
  },
  {
    label: "Image",
    image: "/images/player/imageAvatar3.png",
    value: "3",
  },
  {
    label: "Image",
    image: "/images/player/imageAvatar4.png",
    value: "4",
  },
  {
    label: "Image",
    image: "/images/player/imageAvatar5.png",
    value: "5",
  },
  {
    label: "Image",
    image: "/images/player/imageAvatar6.png",
    value: "6",
  },
  {
    label: "Image",
    image: "/images/player/imageAvatar7.png",
    value: "7",
  },
  {
    label: "Image",
    image: "/images/player/imageAvatar8.png",
    value: "8",
  },
];

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export type CreateProfileContent = {
  title: string;
  description: string;
  nickNameDescription: string;
  continue: string;
};

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

export interface DialogProps {
  show: boolean;
  content: CreateProfileContent;
  onClose: (show: boolean) => void;
  players: PlayerDetails[];
}

export type Avatar = {
  value: string;
  label: string;
  image: string;
  isAvailable?: boolean;
};

type Form = { name: string; avatar: string };

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other} className="backgroundAzul">
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

type AvatarProps = {
  onSelect: (value: string) => void;
  players: PlayerDetails[];
};

const AvatarsGroup = (props: AvatarProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const id = (event.target as HTMLInputElement).value;
    const avatar = avatars.find((o) => o.value === id);
    props.onSelect(avatar?.image || "");
  };

  const isAvatarInUse = (avatar: Avatar) => {
    return props.players.find((o) => o.profileUrl === avatar.image) ? true : false;
  };
  return (
    <FormControl>
      <FormLabel id="demo-row-radio-buttons-group-label"></FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
      >
        <div className="dialogContainer">
          {avatars.map((avatar) => (
            <div className="avatarItem">
              <Avatar alt="Avatar" src={avatar.image} />
              <FormControlLabel
                disabled={isAvatarInUse(avatar)}
                value={avatar.value}
                key={avatar.value}
                control={<Radio onChange={handleChange} color="default" />}
                label=""
              />
            </div>
          ))}
        </div>
      </RadioGroup>
    </FormControl>
  );
};

export default function CreateProfileDialog(props: DialogProps) {
  const navigate = useNavigate();
  const [name, setName] = React.useState("");
  const [avatar, setAvatar] = React.useState("");
  const [errorName, setErrorName] = React.useState(false);
  const [creatingProfile, setCreatingProfile] = React.useState(false);

  const validate = (form: Form) => {
    const nameAvatarSchema = Joi.object({
      name: Joi.string().min(3).max(30).trim().required(),
      avatar: Joi.string().required(),
    });
    return nameAvatarSchema.validate(form);
  };

  const handleClose = async () => {
    const { error } = validate({ name, avatar });
    if (!error) {
      setCreatingProfile(true);
      await UserSession.startAnonimousSession({ name, profileUrl: avatar });
      setCreatingProfile(false);
      props.onClose(false);
      navigate("/game-mode", { replace: true });
    } else {
      setErrorName(error.details.some((detail) => detail.path[0] === "name"));
    }
  };

  console.log(avatar);

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.show}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => {
            props.onClose(false);
          }}
        >
          {props.content.title}
        </BootstrapDialogTitle>
        <DialogContent className="backgroundAzul" dividers>
          <div className="introTextDialog">{props.content.description}</div>
          <AvatarsGroup onSelect={setAvatar} players={props.players} />
          <OutlinedInput
            error={errorName}
            value={name}
            onChange={(event) => setName(event.target.value)}
            className="inputTextWhite"
            placeholder={props.content.nickNameDescription}
          />
        </DialogContent>
        <DialogActions className="backgroundAzul">
          <Button disabled={!avatar || !name} autoFocus onClick={handleClose}>
            {props.content.continue}
          </Button>
        </DialogActions>
      </BootstrapDialog>
      <PopupLoading
        visible={creatingProfile}
        title={props.content.title}
        description=""
      />
    </div>
  );
}
